import React, { FC, useEffect, useState } from 'react';
import {
  PageWrapper,
  GenericList,
  AdditionalCustomersListContent,
  CustomerWithOperations,
  CustomerTypeIcon,
  OperationStateIcon,
  LoadingAnimation,
  FilterListInput,
} from '@dew21/ui';
import axios from 'axios';

export const Customers: FC = (props) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [customers, setCustomers] = useState<CustomerWithOperations[] | null>(null);
  const [filteredCustomers, setFilteredCustomers] = useState<CustomerWithOperations[] | null>(null);

  const fetchUsers = () => {
    return axios.get('/api/customers/operations');
  };

  useEffect(() => {
    setIsLoading(true);
    fetchUsers().then((response) => {
      setCustomers(response.data);
      setFilteredCustomers(response.data);
      setIsLoading(false);
    }).catch((error) => {
      setIsLoading(false);
      console.log(error);
    });
  }, []);

  return (
    <PageWrapper
      breadCrumb={[{ title: 'Kunden', path: '/customers' }]}
      marginal={{
        items: [
          {
            text: 'Neuen Kunden hinzufügen',
            icon: 'add-user',
            route: '/customers/add',
          }],
      }}>

      {
        (customers && customers.length > 0) && <FilterListInput
          id={'filter-customers'}
          label={'Kundensuche'}
          onChange={(value: string | null) => {
            if (value && customers) {
              const condition = customers.filter((customer) => {
                const matchingString = `${customer.name}`.toLowerCase();
                const matchingStringCustomerNumber = `${customer.customerNumber}`.toLowerCase();
                if (matchingString.includes(value.toLowerCase()) || matchingStringCustomerNumber.includes(value.toLowerCase())) {
                  return customer;
                }
              }).filter((customer) => customer !== null) || customers;
              setFilteredCustomers(condition);
            } else {
              setFilteredCustomers(customers);
            }
          }}
          placeholder={'Unternehmensname oder GP-Nummer'} />
      }

      {
        filteredCustomers && filteredCustomers.length > 0 && !isLoading ? (
          <GenericList
            displayColumnNames={true}
            collapsible={true}
            additionalRenderFn={(item: CustomerWithOperations, collapsed: boolean) => (
              <AdditionalCustomersListContent
                item={item}
                collapsed={collapsed}
                editRoute={'/customers/{id}'}
              />
            )}
            columns={[
              { name: 'name', displayName: 'Unternehmen', sortable: true },
              { name: 'customerNumber', displayName: 'GP-Nummer', sortable: true },
              {
                name: 'type', displayName: 'Zielgruppe', sortable: true, widthTemplate: '8.5rem', formatFn: (value) => (
                  <CustomerTypeIcon value={value} />
                ),
              },
              {
                name: 'operations',
                displayName: 'Vorgänge',
                sortable: false,
                widthTemplate: '8rem',
                formatFn: (value: any[]) => (
                  <OperationStateIcon value={value} />
                ),
              },
            ]}
            items={filteredCustomers}
            countLabel={`${filteredCustomers.length} Kunden gefunden`} />
        ) : 'Keine Kunden gefunden'
      }

      {
        isLoading && <LoadingAnimation overlay transparent />
      }
    </PageWrapper>
  );
};
